<template>
  <div class="web">
    <div class="Empty">
      <div class="EmptyImage">
        <img src="../../../assets/images/cannotAccess.png" alt="" />
      </div>
      <p class="text">网站功能暂未开放，敬请期待...</p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.text {
  color: #9b9b9b;
  margin-top: 21.33333vw;
  font-size: 5.86667vw;
}
</style>
